import { FC, useContext } from 'react'
import { ToolbarButton } from './ToolbarButton'
import { CutterContext } from '../contexts/CutterContext'
import { useHotkey } from '../../hooks/useHotkey'
import SvgSelect from '../../components/icons/Select'
import { AppContext } from '../../AppContext'
import { logger } from '../../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { CutterActionType } from '../enums/CutterActionType'

export const ToolbarCrop: FC = () => {
  const { hotkeysEnabled } = useContext(AppContext)
  const { crop, selection } = useContext(CutterContext)

  useHotkey(
    (event: KeyboardEvent) => event.key === 'Enter',
    () => {
      logger.log(LogActionType.HotkeyPress, { type: CutterActionType.Crop })

      crop()
    },
    hotkeysEnabled,
  )

  return (
    <ToolbarButton
      icon={<SvgSelect />}
      hotkey="Enter"
      disabled={!selection}
      onClick={() => {
        logger.log(LogActionType.ToolbarButtonClick, { type: CutterActionType.Crop })

        crop()
      }}
    >
      Crop
    </ToolbarButton>
  )
}
